import AccessoryModal from './accessory-modal';

export default AccessoryModal;
